import {lory} from 'lory.js';
import du from '../utils/dom-utilities';

/**
 * Synchronize Two Slider Together
 *
 * @param {HTMLElement} el - The slider element
 * @param {lory} source - The slider lory object
 * @param {lory} target - The slider lory object to sync with
 * @param {HTMLElement} desc - The desc element
 */
function _syncSliders(el, source, target, desc) {
    el.addEventListener('after.lory.slide', thatEvt =>  {
        let sourceIndex = source.returnIndex();
        let targetIndex = target.returnIndex();

        thatEvt.stopPropagation();

        if (sourceIndex !== targetIndex) {
            target.slideTo(sourceIndex);
            _showDesc(desc, sourceIndex);
        }
    });
}

/**
 * Show desc elemnt
 *
 * @param {HTMLElement} desc - The slider descpription node
 * @param {Number} index - The index to show
 */
function _showDesc(desc, index=0) {
    du.queryAll('[data-slider-descindex]', desc).forEach(elem => {
        if (parseInt(elem.getAttribute('data-slider-descindex')) === index) {
            elem.classList.add('state--active');
        } else {
            elem.classList.remove('state--active');
        }
    });
}

/**
 * Change Slide On Click
 *
 * @param {HTMLElement} el
 * @param {lory} target
 * @param {String} slideclass
 */
function _changeSlideOnClick(el, target, slideclass) {
    let _isNavigating = false;

    el.addEventListener('click', thatEvt => {
        if (_isNavigating) {
            thatEvt.preventDefault();
            thatEvt.stopPropagation();

            return false;
        }

        if (du.hasClass(thatEvt.target, slideclass)) {
            target.slideTo(
                parseInt(thatEvt.target.getAttribute('data-slider-controlindex'))
            );
        }

        return true;
    });

    el.addEventListener('on.lory.touchstart', thatEvt => {
        _isNavigating = true;

        thatEvt.stopPropagation();
        thatEvt.preventDefault();
    });

    el.addEventListener('on.lory.touchmove', thatEvt => {
        _isNavigating = true;

        thatEvt.stopPropagation();
        thatEvt.preventDefault();
    });


    el.addEventListener('on.lory.touchend', () => {
        _isNavigating = !_isNavigating;
    });

    el.addEventListener('before.lory.slide', thatEvt => {
        _isNavigating = true;

        thatEvt.stopPropagation();
        thatEvt.preventDefault();
    });

    el.addEventListener('after.lory.slide', () => {
        _isNavigating = !_isNavigating;
    });
}

/**
 * Slider
 *
 * @export
 * @param {HTMLElement} content Slider module
 * @param {Number} start Index to start the slider slides
 * @param {Boolean} resetOnLoad To seset the main slider after window load (To prevent visual bug, on slider width 100%)
 * @param {Number} max Maximum of visible controls slides
 */
/* eslint-disable max-statements */
export default function slider(content, start = 0, resetOnLoad = false, max = 5) {
    if (!du.isElement(content)) {
        console.error(
            '"content" argument must be a valid HTMLElement'
        );
        return;
    }

    const sliderEl = content.querySelector('.js-slider-slider');
    const controlsEl = sliderEl.parentNode.querySelector('.js-slider-controls');
    const descEl = content.querySelector('.js-slider-desc');

    const frameClass = 'js-slider-frame';
    const slidesClass = 'js-slider-slides';
    const slideClass = 'js-slider-slide';

    const sliderSlides = du.queryAll('.' + slideClass, sliderEl);

    let slider = lory(sliderEl, {
        infinite: 1,
        classNameFrame: frameClass,
        classNameSlideContainer: slidesClass
    });

    let controls = lory(controlsEl, {
        infinite: (sliderSlides.length <= max ? sliderSlides.length : max),
        classNameFrame: frameClass,
        classNameSlideContainer: slidesClass,
        enableMouseEvents: true
    });

    content.classList.add(
        sliderSlides.length <= max ?
            'slider--has-' + sliderSlides.length + '-slides' :
            'slider--has-a-lot-slides'
    );

    if (resetOnLoad) {
        du.onEvent(window, 'load', () => {
            slider.reset();
        });
    }
    // The Slider and the Controls Must Be Synchronize
    _syncSliders(sliderEl, slider, controls, descEl);
    _syncSliders(controlsEl, controls, slider, descEl);

    _showDesc(descEl, start);
    slider.slideTo(start);

    _changeSlideOnClick(controlsEl, slider, slideClass);

    return {
        'slider' : {
            slider,
            sliderEl
        },
        'controls' : {
            controls,
            controlsEl
        }
    };
};
/* eslint-enable max-statement */

/**
 * Init slider with the given selector
 *
 * @param {String} cssSelector
 */
export function initSliders(cssSelector) {
    return du.queryAll(cssSelector).map(elem => {
        return slider(elem, 0, true);
    });
};



// WEBPACK FOOTER //
// ./src/main/js/components/slider.js